import { render, staticRenderFns } from "./TrackerDeleteDataForm.vue?vue&type=template&id=5988e310&scoped=true&"
import script from "./TrackerDeleteDataForm.vue?vue&type=script&lang=js&"
export * from "./TrackerDeleteDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5988e310",
  null
  
)

export default component.exports